import { apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  notifications: [],
  notification: null,
  isFetchingNotifications: false,
}

const createNotificationsSlice = (set, get) => ({
  ...initialState,
  setNotification: (notification) => {
    set(() => ({ notification: notification }))
  },
  fetchNotifications: async (param = '') => {
    set(() => ({isFetchingNotifications: true}))
    try {
      const response = await fetch(
        `${apiUrlV2}/notifications${param}`,
        { headers: get().requestHeaders }
      )
      const data = await response.json()
      set(() => ({ notifications: data.data, isFetchingNotifications: false }))
    } catch (err) {
      get().logError('Unable to retrieve notifications at this time.', err)
    }
  },
  markNotificationAsRead: async (id) => {
    try {
      const response = await fetch(
        `${apiUrlV2}/notifications/${id}/mark_read`,
        {
          headers: get().requestHeaders,
          method: 'PATCH'
        }
      )
    } catch (err) {
      get().logError('There was an error marking a notification as read.', err)
    } finally {
      get().fetchNotifications()
    }
  },
  resetNotificationsSlice: () => set(initialState)
})

export default createNotificationsSlice